exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.mat-input-element {\n  caret-color: black !important; }\n", ""]);

// exports
